<template>
  <div class="rm-screen">
    <div v-if="loading.fetchChildRestaurants" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!restaurants.length" class="rm-empty">
      <template v-if="filters.search">{{ $t("report_mobile.no_results_for", { search: filters.search }) }}</template>
      <template v-else>
        <v-icon size="40" color="#8a817a">mdi-storefront-outline</v-icon>
        {{ $t("no_data_available") }}
      </template>
    </div>

    <template v-else>
      <div class="rm-stats rm-stats--pair">
        <div class="rm-stat rm-stat--inverse">
          <span class="rm-stat__label">{{ $t("restaurants") }}</span>
          <span class="rm-stat__value rm-num">{{ restaurants.length }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("report_desktop.total_meals") }}</span>
          <span class="rm-stat__value rm-num">{{ mealTotal }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="restaurant in restaurants" :key="restaurant.key" class="rm-mrow">
          <div class="rm-mrow__main">
            <span class="rm-mrow__name">{{ restaurant.name }}</span>
            <span class="rm-mrow__value rm-num">{{ restaurant.count }}</span>
          </div>
          <div
            class="rm-progress rm-rest-share"
            role="progressbar"
            :aria-valuenow="restaurant.count"
            aria-valuemin="0"
            :aria-valuemax="mealTotal"
          >
            <div class="rm-progress__fill" :style="{ width: `${restaurant.percent}%` }"></div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import ReportMealsTabRestaurants from "@/components/report/meals/tabs/ReportMealsTabRestaurants.vue";
import { percentOf } from "../../shared/takenMath";
import "./reportMobileMealCards.scss";

/**
 * Mobilni prikaz "Restorani": broj obroka po restoranu koji hrani firme, sa udelom u ukupnom broju. Pretraga je u
 * lupi zaglavlja. Nasleđuje učitavanje, štampu i Excel iz ReportMealsTabRestaurants (izvoz zadržava red "Ukupno").
 */
export default {
  name: "ReportMobileRestaurants",
  extends: ReportMealsTabRestaurants,
  computed: {
    /** Red "Ukupno" stiže iz izveštaja kao poslednja stavka; ovde je zamenjen brojkom gore. */
    totalRow() {
      const names = ["ukupno", "total", String(this.$t("total")).toLowerCase()];
      return this.childRestorans.find((item) => names.includes(String(item.name).trim().toLowerCase())) || null;
    },
    own() {
      return this.childRestorans.filter((item) => item !== this.totalRow);
    },
    mealTotal() {
      return this.totalRow
        ? Number(this.totalRow.count) || 0
        : this.own.reduce((sum, item) => sum + (Number(item.count) || 0), 0);
    },
    /** Restorani po broju obroka (najviše prvi); pretraga po nazivu. */
    restaurants() {
      const search = this.filters.search;
      const found = search ? this.customSearch(this.own, [{ value: "name" }], search) : this.own;
      return [...found]
        .sort((a, b) => (Number(b.count) || 0) - (Number(a.count) || 0) || a.name.localeCompare(b.name))
        .map((item, index) => ({
          key: `${item.name}-${index}`,
          name: item.name,
          count: Number(item.count) || 0,
          percent: percentOf(Number(item.count) || 0, this.mealTotal),
        }));
    },
  },
};
</script>

<style lang="scss">
.rm-theme .rm-rest-share {
  margin-top: 8px;
  height: 6px;
}
</style>
